import Service from './abstract';
import _ from 'lodash';
import page from '../constants/pages/page';

const defaultOptions = {
    order: 'created_at-DESC',
    pageSize: page.pageSize
};

class Locations extends Service {
    constructor () {
        super('locations');
    }

    getAddresses (options = {}) {
        return this.get({
            url: `${this.basePath}/addresses`,
            qs: _.defaultsDeep(options, defaultOptions)
        });
    }
}

export default new Locations();
